// extracted by mini-css-extract-plugin
module.exports = {"mCard":"qi-z","image":"ri-z","imageNoBackground":"si-z","fullWidth":"ti-z"};